export let LinkDirective = () => ({
  restrict: 'E',
  link: (scope, elem, attrs) => {
    if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
      elem.on('click', e => {
        e.preventDefault();
      });
    }

    // fix to prevent memory leak
    scope.$on('$destroy', () => {
      // remove listener
    });
    elem.on('$destroy', () => {
      scope.$destroy();
    });
  },
});

export default 'a';
